<template>
  <div class="container">
    <app-document-panel v-if="exists || createNew" />
    <app-landing v-else v-on:createNewDoc="createNewDoc" />
  </div>
</template>

<script>
  /* eslint-disable */
  import Landing from './Landing.vue';
  import DocumentPanel from './DocumentPanel.vue';

  export default {
    data() {
      return {
        createNew: false
      }
    },
    methods: {
      createNewDoc(name) {
        this.createNew = true;
        this.$store.dispatch("setName", name);
      }
    },
    computed: {
      document() {
        return this.$store.getters.document;
      },
      exists() {
        return this.$store.getters.docExists;
      }
    },
    components: {
      appLanding: Landing,
      appDocumentPanel: DocumentPanel
    }
  }

</script>

<style>
  #app {
    padding-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue